import React, { useCallback, useEffect } from 'react';
import { Waypoint } from 'react-waypoint';
import { ListBranch, ListBranchState } from '../types-store';

interface UserMembersListItemContainerProps {
  id: number;
  children?: React.ReactNode;
  listBranch: ListBranch;
  listBranchState: ListBranchState;
  loadFromParent: (id: number, startIndex: number) => void;
}

export const UserMembersListItemsContainer: React.FC<UserMembersListItemContainerProps> = ({
  listBranch, listBranchState, id, loadFromParent, children
}) => {

  const loadUserMember = useCallback(
    (appendToList: boolean) => {

      if (!listBranchState?.open || listBranchState?.fetching) {
        return;
      }

      if (appendToList || !listBranch) {

        const startIndex = appendToList && listBranch?.items
          ? listBranch.items.length
          : 0;

        if (startIndex > 0 && (listBranch?.items?.length ?? 0) >= (listBranch?.numberOfResults ?? 0)) {
          return;
        }

        loadFromParent(id, startIndex);
      }
    },
    [listBranch, listBranchState, id, loadFromParent]);

  const onLoadMore = useCallback(
    () => loadUserMember(true),
    [loadUserMember]
  );

  useEffect(() => loadUserMember(false),
    [loadUserMember]
  );

  if (!listBranch?.items?.length) {
    return null;
  }

  return <div>
    {children}
    <Waypoint key={`wpUserMembers${id}`} onEnter={onLoadMore} scrollableAncestor={window} bottomOffset="-10%" />
  </div>;
};
